import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import { defineComponent, ref } from 'vue';
import Home from './views/Home.vue';
import CwFooter from './components/_share/Footer.vue';

const __default__ = defineComponent({
  name: 'App',
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const mode = ref(process.env.NODE_ENV);
const version = ref(process.env.VUE_APP_VERSION);
console.log(`(${mode.value}) app version: `, version.value);

return (_ctx: any,_cache: any) => {
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_main, { style: `position: relative;` }, {
        default: _withCtx(() => [
          _createVNode(Home),
          _createVNode(CwFooter)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})